import './style/main.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'


import * as THREE from 'three'
import CameraControls from 'camera-controls';
import USDZExporter from 'three/examples/jsm/exporters/USDZExporter';

import * as JSZip from 'jszip';
import * as JSZipUtils from 'jszip-utils';
import 'jszip-utils';
import * as Controller from './modules/controller';
import '@simonwep/pickr/dist/themes/monolith.min.css'
import '@simonwep/pickr/dist/themes/classic.min.css'; 

/**
 * Sizes
 */
const sizes = {}
const canvas = document.querySelector('.canvas-container');
console.log(canvas);
sizes.width = canvas.clientWidth
sizes.height = canvas.clientHeight


// Scene
let scene = new THREE.Scene()
let camera;
let cameraControls;
const clock = new THREE.Clock();
CameraControls.install( { THREE: THREE } );

Controller.initConfig();

window.addEventListener('resize', () =>
{
    // Save sizes
    let canvas = document.querySelector('.canvas-container');
    sizes.width = canvas.clientWidth
    sizes.height = canvas.clientHeight

    if(camera != null){
        // Update camera
        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()

    }
    // Update renderer
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(sizes.width, sizes.height, true)
})

const renderer = new THREE.WebGLRenderer({
    canvas: document.querySelector('.webgl'),
    antialias: true, 
    alpha: true
})



/**
 * Loop
 */
const loop = () =>
{
    
    if(scene == null || camera == null)
        return;

	const delta = clock.getDelta();
	const hasControlsUpdated = cameraControls.update( delta );
    
   // 
	renderer.render( scene, camera );
    if(hasControlsUpdated)
        Controller.updateButtonPosition(renderer, camera);

    window.requestAnimationFrame(loop)
}



const loadModel = (name, path, callback = null) => {

    const loader = new THREE.ObjectLoader();
    let loadBar = $(".load-bar");
    
    JSZipUtils.getBinaryContent('./assets/'+name+'.zip?v=2', { 

        progress: (update) =>  {
            //console.log(e.percent + "% loaded");
            $(loadBar).text(parseInt(update.percent) + '%');
        },
        callback: (err, data) => {
        if(err) {
            throw err; // or handle err
        }

        $(".loading").text("Inizializzazione scena...");
        // loadStatus.nativeElement.innerHTML = 'Caricamento...';
        //clearInterval(timer);
        JSZip.loadAsync(data).then((zip) => {
            let sceneFile = zip.file(name+'.json');
            sceneFile.async('string', (update) => {
                //console.log(update);
                $(loadBar).text(parseInt(update.percent) + '%');
            }).then((objectJson) => {

                    loader.parse(JSON.parse(objectJson), (parsedObj)=>{
                    objectJson = null;
                    sceneFile = null;
                    if(callback != null){
                        callback(parsedObj);
                    }

                });
            });

        });
    }});
    
}

loadModel('scenaJSON_FInestra_08', '/', async (obj) => {
    
    scene = obj;
    camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 10000);

    scene.add(camera);
    //camera.position.set( 0, 0, 0.01);
    camera.position.set(0, 75, 238);

    renderer.setPixelRatio(window.devicePixelRatio)
    renderer.setSize(sizes.width, sizes.height)
        
    renderer.outputEncoding = THREE.sRGBEncoding;
    
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = 1;
    renderer.toneMapping = 0;
    renderer.toneMappingExposure = 1;
    renderer.physicallyCorrectLights = false;

    cameraControls = new CameraControls( camera, renderer.domElement );
    Controller.init(scene, cameraControls);

    cameraControls.minDistance = 0;
    cameraControls.maxDistance = Infinity;
    cameraControls.setLookAt(0, 45, 238, 0,45,0, false) 
    cameraControls.enabled = false;
/*
    await cameraControls.rotate(0 * THREE.MathUtils.DEG2RAD, 15 * THREE.MathUtils.DEG2RAD)
    cameraControls.moveTo(0, 40, 0)*/

    //cameraControls.boundaryEnclosesCamera = true;
    /*
    cameraControls.maxAzimuthAngle = 0.3;
    cameraControls.minAzimuthAngle = -0.3;
    
    cameraControls.minDistance = 80;
    cameraControls.maxDistance = 280;
    cameraControls.minPolarAngle = 1.4;
    cameraControls.maxPolarAngle = 1.6;
    */
    

    cameraControls.addEventListener('controlend', ()=>{
        //console.log(camera.position)
        //console.log(camera.rotation)

        
        //console.log(camera.rotation)
        //cameraControls.setOrbitPoint( 0, 0, 0)
    });

    cameraControls.boundaryEnclosesCamera = false;

    let ambiente = scene.getObjectByName('Ambiente_Finestra');
    let boundingBox = new THREE.Box3().setFromObject(ambiente);

    boundingBox = boundingBox.expandByVector(new THREE.Vector3(-20,-28,50));

    //cameraControls.setBoundary(boundingBox);  
    cameraControls.maxAzimuthAngle = THREE.MathUtils.degToRad(60)
    cameraControls.minAzimuthAngle = THREE.MathUtils.degToRad(-60)
    cameraControls.maxPolarAngle = THREE.MathUtils.degToRad(100)
    cameraControls.minPolarAngle = THREE.MathUtils.degToRad(70)

    setTimeout(()=>{ loop() }, 200)
    //loop();

});